var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9149 11.572C4.1195 11.572 1.85352 9.306 1.85352 6.5106C1.85352 3.7152 4.1195 1.44922 6.9149 1.44922C9.7103 1.44922 11.9763 3.7152 11.9763 6.5106C11.9763 9.306 9.7103 11.572 6.9149 11.572ZM6.9149 10.5597C7.98879 10.5597 9.01869 10.1331 9.77805 9.37375C10.5374 8.6144 10.964 7.58449 10.964 6.5106C10.964 5.43671 10.5374 4.4068 9.77805 3.64745C9.01869 2.8881 7.98879 2.4615 6.9149 2.4615C5.84101 2.4615 4.8111 2.8881 4.05175 3.64745C3.29239 4.4068 2.86579 5.43671 2.86579 6.5106C2.86579 7.58449 3.29239 8.6144 4.05175 9.37375C4.8111 10.1331 5.84101 10.5597 6.9149 10.5597ZM6.40876 3.97991H7.42104V4.99219H6.40876V3.97991ZM6.40876 6.00446H7.42104V9.04129H6.40876V6.00446Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1473,
    height: 12.1473,
    fill: "white",
    transform: "translate(0.841797 0.437012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.3b120b3ad53d235a593517628d7b6e98.svg";
export { ForwardRef as ReactComponent };